import request from '@/services/interceptor.js'

const base = (commessaId, posizioneId) => `/commesse/${commessaId}/posizioni/${posizioneId}/trasmittanza`

export const get_trasmittanza = (commessaId, posizioneId) => {
    return request({ url: base(commessaId, posizioneId), method: 'get', loadingBar: true })
}

export const calcola_trasmittanza = (commessaId, posizioneId, dati) => {
    return request({ url: `${base(commessaId, posizioneId)}/calcola`, method: 'post', data: dati, loadingBar: true })
}

// ricostruisci=true (10077-2): i nodi vengono ricostruiti dall'anagrafica; false: Uf dai nodi inviati.
export const uf_trasmittanza = (commessaId, posizioneId, dati, ricostruisci = true) => {
    return request({ url: `${base(commessaId, posizioneId)}/uf`, method: 'post', data: dati, params: { ricostruisci }, loadingBar: true })
}

export const salva_trasmittanza = (commessaId, posizioneId, dati) => {
    return request({ url: base(commessaId, posizioneId), method: 'put', data: dati, loadingBar: true })
}

export const nodi_disponibili = (params) => {
    return request({ url: '/trasmittanza/nodi-disponibili', method: 'get', params, loadingBar: true })
}

export const info_riempimento = (codArticolo) => {
    return request({ url: '/trasmittanza/riempimento', method: 'get', params: { codArticolo }, loadingBar: true })
}

const basePrestazioni = (commessaId, posizioneId) => `/commesse/${commessaId}/posizioni/${posizioneId}/prestazioni`

export const get_prestazioni = (commessaId, posizioneId) => {
    return request({ url: basePrestazioni(commessaId, posizioneId), method: 'get', loadingBar: true })
}

export const calcola_prestazioni = (commessaId, posizioneId, dati) => {
    return request({ url: `${basePrestazioni(commessaId, posizioneId)}/calcola`, method: 'post', data: dati, loadingBar: true })
}

export const salva_prestazioni = (commessaId, posizioneId, dati) => {
    return request({ url: basePrestazioni(commessaId, posizioneId), method: 'put', data: dati, loadingBar: true })
}
